import { useQuery } from 'react-query';

//import { config } from 'config';
import { IProjection } from 'features/seismic/models/interfaces/IProjection';
import { IIntersections } from 'features/seismic/models/interfaces/IIntersection';
import { getParamsFromUrl, hexToString } from 'features/seismic/utils/seismicUrlUtils';
import { TenantConfig } from '../model/TenantConfig';
import { axios } from 'configurations/axios';

export const useTenantConfigurationApi = (ignoreTenant = false) => {
    return useQuery('TenantConfiguration', async () => {
        const paramsViewer = getParamsFromUrl();
        let tenantToken = paramsViewer.tenantToken;
        if (!!paramsViewer.state) {
            const rawStateContent = paramsViewer.state;
            const stateContent = rawStateContent.split(';')[1];
            const tenantRegex = /tenantToken=([^&]*)/;
            const match = stateContent?.match(tenantRegex);
            if (!!match) {
                tenantToken = match[1];
            }
            //navigate(decodedState!);
        }
        console.log('ignore tenant', ignoreTenant);

        let hostTenant = '';
        if (window.location.host.indexOf('viewer-app') > -1) {
            hostTenant = window.location.protocol + '//' + window.location.host.replace('viewer-app', 'seismic-api') + '/Viewer/Tenant/Configuration?tenantToken=' + paramsViewer.tenantToken + '&sourceApi=' + paramsViewer.sourceApi;
        }
        else if (window.location.host.indexOf('localhost') > -1) {
            hostTenant = 'https://localhost:44321/Viewer/Tenant/Configuration';
            //hostTenant = 'https://stagging-seismic-api.geopostenergy.com/Viewer/Tenant/Configuration';
        }
        else {
            let currentHost = 'prod-seismic-api.geopostenergy.com';

            if (window.location.host.includes('stagging-') || window.location.host.includes('staging-') || window.location.host.includes('osdu')) {
                currentHost = 'stagging-seismic-api.geopostenergy.com';
            }
            else if (window.location.host.includes('development-')) {
                currentHost = 'development-seismic-api.geopostenergy.com';
            }

            if (window.location.host.includes('staging-ecopetrol.geopostenergy')) {
                currentHost = 'development-seismic-api.geopostenergy.com';
            }

            hostTenant = `https://${currentHost}/Viewer/Tenant/Configuration?tenantToken=` + paramsViewer.tenantToken + '&sourceApi=' + paramsViewer.sourceApi;
        }

        if ((window.location.href.indexOf('callback') > -1 || !paramsViewer.tenantToken) && window.location.host.indexOf('localhost') === -1) {
            hostTenant = window.location.protocol + '//' + window.location.host.replace('-app-', '-api-') + '/Viewer/Tenant/Configuration?tenantToken=d1b07f73-0c36-449e-bab7-756ed0c07640&sourceApi=tgs';
        }

        if (window.location.href.indexOf('viewer-dev.datalake.tgs.com') > -1) {
            hostTenant = 'https://viewer-seismic-api-dev.datalake.tgs.com/Viewer/Tenant/Configuration?tenantToken=d1b07f73-0c36-449e-bab7-756ed0c07640&sourceApi=tgs';
        }

        if (window.location.href.indexOf('viewer-test.datalake.tgs.com') > -1) {
            hostTenant = 'https://viewer-seismic-api-test.datalake.tgs.com/Viewer/Tenant/Configuration?tenantToken=d1b07f73-0c36-449e-bab7-756ed0c07640&sourceApi=tgs';
        }

        if (window.location.href.indexOf('viewer.datalake.tgs.com') > -1) {
            hostTenant = 'https://viewer-seismic-api.datalake.tgs.com/Viewer/Tenant/Configuration?tenantToken=d1b07f73-0c36-449e-bab7-756ed0c07640&sourceApi=tgs';
        }

        if (window.location.href.indexOf('gcp-gpost-seismic-app-dev.geopostenergy.com') > -1) {
            hostTenant = 'https://gcp-gpost-seismic-api-dev.geopostenergy.com/Viewer/Tenant/Configuration?tenantToken=d1b07f73-0c36-449e-bab7-756ed0c07640&sourceApi=tgs';
        }

        if (window.location.href.indexOf('vm-poc-yl7c-iglass-viewer') > -1) {
            hostTenant = 'http://vm-poc-yl7c-iglass-viewer:8500/Viewer/Tenant/Configuration?tenantToken=' + paramsViewer.tenantToken + '&sourceApi=' + paramsViewer.sourceApi;
        }

        if (window.location.href.indexOf('azurewebsites.net') > -1) {
            hostTenant = 'https://seismic-api-cjfagfhacahwgve3.brazilsouth-01.azurewebsites.net/Viewer/Tenant/Configuration?tenantToken=3f52b10cf1b24202b454a80f7cffe482';
        }

        if (window.location.href.indexOf('seismic-front') > -1) {
            const host = window.location.host.replace('seismic-front', 'seismic-api');
            hostTenant = window.location.protocol + '//' + host + '/Viewer/Tenant/Configuration';
        }

        if (window.location.href.indexOf('presalpetroleo.gov.br') > -1) {
            hostTenant = 'https://kdm-seismic-api.presalpetroleo.gov.br/Viewer/Tenant/Configuration?tenantToken=3f52b10cf1b24202b454a80f7cffe482';
        }

        if (window.location.href.indexOf('/geopost/') > -1) {
            hostTenant = window.location.origin + '/geopost/api/Viewer/Tenant/Configuration';
        }

        if (window.location.host.indexOf('tgsaws') > -1) {
            const tenantHost = window.location.host.replace('viewer', 'seismic-api');
            hostTenant = window.location.protocol + '//' + tenantHost + '/Viewer/Tenant/Configuration?tenantToken=d1b07f73-0c36-449e-bab7-756ed0c07640';
        }
        //hostTenant = 'https://gcp-gpost-seismic-api-dev.geopostenergy.com/Viewer/Tenant/Configuration?tenantToken=d1b07f73-0c36-449e-bab7-756ed0c07640&sourceApi=tgs';
        //hostTenant = 'https://stagging-seismic-api.geopostenergy.com/Viewer/Tenant/Configuration';
        //hostTenant = 'https://stagging-seismic-api.geopostenergy.com/Viewer/Tenant/Configuration?tenantToken=77fb6644-96fc-45d5-a73f-bcf504c73a81';
        //hostTenant = 'https://stagging-seismic-api.geopostenergy.com/Viewer/Tenant/Configuration?tenantToken=' + paramsViewer.tenantToken + '&sourceApi=' + paramsViewer.sourceApi;
        //hostTenant = 'https://stagging-seismic-api.geopostenergy.com/Viewer/Tenant/Configuration?tenantToken=ea7aaec6-c44d-4980-91d3-f95e429d9923';
        //hostTenant = 'https://localhost:44321/Tenant/Configuration?tenantToken=' + paramsViewer.tenantToken;
        //h
        try {
            const response = await axios.request<TenantConfig>({
                method: 'get',
                url: hostTenant,
                params: {
                    tenantToken: tenantToken
                }
            });

            const tenantConfig = response.data as TenantConfig;

            if (window.location.href.toLowerCase().indexOf('/app-viewer/') > -1) {
                tenantConfig.parentApplicationHost = '/Map';
            }

            return tenantConfig;
        }
        catch (exception) {
            return exception as Error;
        }
    }, {
        refetchOnWindowFocus: false,
        enabled: !ignoreTenant
    });
};

export const useTenantConfigurationApiAxios = async () => {
    const paramsViewer = getParamsFromUrl();
    let hostTenant = '';
    if (paramsViewer.tenantToken === 'd1b07f73-0c36-449e-bab7-756ed0c07640') {
        hostTenant = window.location.host.replace('-app-', '-api-') + '/Viewer/Tenant/Configuration?tenantToken=' + paramsViewer.tenantToken + '&sourceApi=' + paramsViewer.sourceApi;
    } else {
        hostTenant = window.location.host.indexOf('localhost') > -1 ? 'https://localhost:44321/Viewer/Tenant/Configuration' : 'https://development-seismic-api.geopostenergy.com/Viewer/Tenant/Configuration?tenantToken=' + paramsViewer.tenantToken + '&sourceApi=' + paramsViewer.sourceApi;
    }

    if (window.location.href.indexOf('callback') > -1 || !paramsViewer.tenantToken) {
        hostTenant = window.location.protocol + '//' + window.location.host.replace('-app-', '-api-') + '/Viewer/Tenant/Configuration?tenantToken=d1b07f73-0c36-449e-bab7-756ed0c07640&sourceApi=tgs';
    }

    const response = await axios.request<TenantConfig>({
        method: 'get',
        url: hostTenant,
        params: {
            tenantToken: paramsViewer.tenantToken
        }
    });

    return response.data;
};